import { load } from 'poly-eshop4/eshop/ui/js/util';

$(document).on('click', '[data-request-item-delivery-time]', function() {
  const quantity = $(this).closest('[data-item-detail]').find('input[name="quantity"]');

  $.ajax({
    method: 'GET',
    url: $(this).attr('data-request-item-delivery-time'),
    data: {
      quantity: quantity && quantity.val(),
    },
  }).done((response) => {
    $(response).appendTo($('body')).foundation().foundation('open');
  });
});

$(document).on('submit', '[data-request-item-delivery-time-form]', function(event) {
  event.preventDefault();
  const $form = $(this);
  const $reveal = $form.closest('[data-reveal]');
  load(
    $reveal,
    $.ajax({
      url: $form.attr('action'),
      data: $form.serialize(),
      method: 'post',
    }),
  ).done((response) => {
    if (!response) {
      setTimeout(() => $reveal.foundation('close'), 1500);
    } else {
      $reveal.foundation('close');
    }
  });
});

$(document).on('click', '[data-request-item-price]', function() {
  const quantity = $(this).closest('[data-item-detail]').find('input[name="quantity"]');

  $.ajax({
    method: 'GET',
    url: $(this).attr('data-request-item-price'),
    data: {
      quantity: quantity && quantity.val(),
    },
  }).done((response) => {
    $(response).appendTo($('body')).foundation().foundation('open');
  });
});

$(document).on('submit', '[data-request-item-price-form]', function(event) {
  event.preventDefault();
  const $form = $(this);
  const $reveal = $form.closest('[data-reveal]');
  load(
    $reveal,
    $.ajax({
      url: $form.attr('action'),
      data: $form.serialize(),
      method: 'post',
    }),
  ).done((response) => {
    if (!response) {
      setTimeout(() => $reveal.foundation('close'), 1500);
    } else {
      $reveal.foundation('close');
    }
  });
});
